import { computed } from 'vue';

import { GlobalState } from '@/global';
import { hasPermission } from '@/shared/helpers/permissions.helpers';

import { canEditAllBookings, canEditOwnBookings } from '../bookings/permissions';

// `sp` alone must not unlock full salespoint off a workstation. `spWithoutInstall` grants it on any
// device; plain `sp` only on an installed workstation — keeping the salespoint *mode* in step with
// the route's access gate (sales/routes.ts), so a non-workstation user with just `sp` lands in the
// bookings-only flow rather than a full register.
export const canAccessFullSalespoint = computed(
    () => hasPermission('sales', 'spWithoutInstall') || (GlobalState.isWorkstation && hasPermission('sales', 'sp'))
);
// A predefined discount flagged `restricted` may only be applied by staff granted access to the full
// set of pre-defined discounts. Without it they are limited to the unrestricted ones.
export const canUseRestrictedDiscounts = computed(() => hasPermission('sales', 'spRestrictedDiscounts'));

// A fully custom (manual) discount — a cashier-entered type and amount with no predefined discount
// behind it — requires this capability.
export const canUseCustomDiscounts = computed(() => hasPermission('sales', 'spCustomDiscounts'));

export const canAccessSalespointViaBookings = computed(() => canEditAllBookings.value || canEditOwnBookings.value);
export const bookingsOnlySalespointMode = computed(() => canAccessSalespointViaBookings.value && !canAccessFullSalespoint.value);
export const bookingsEditOwnSalespointMode = computed(
    () => bookingsOnlySalespointMode.value && !canEditAllBookings.value && canEditOwnBookings.value
);
